module.exports = __webpack_public_path__ + "img/rock-big-14.4831e079.png";